export default async function GetCorrespondences(
    policyNumber,
    distributorNo,
    sourceSystem
    ) {
    const baseUrl = "/api/tal/policy/GetCorrespondences"; 

    const constructUrl = () => {
        var origin = "";

        if (window.location.origin === "http://localhost:3000") {
            // note: local testing
            origin = "https://adviser-local.delivery.lan";
        }
        return origin + baseUrl + "?policynumber=" + policyNumber +
            "&distributorNo=" + distributorNo +
            "&sourceSystem=" + sourceSystem;           
    }

    try {
        const response = await fetch(constructUrl(), {
            "method": "GET"
        });

        if (!response) {
            throw Error("No response");
        }
        else if (!response.ok) {
            throw Error(response.statusText);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}